export default __webpack_public_path__ + "static/media/squared_minus.13d1f282.svg";